// Comportamenti specifici della pagina prodotto Cleve (layout 2026).
// Da convertire: public/proposta/assets/js/cleve.js
// Stato avanzamento: vedi docs/2026-layout-CHANGELOG.md

/* ── Mappa flusso operativo — reveal sequenziale in loop ─────────── */
(function () {
    'use strict';
    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    var track = document.getElementById('flowmap');
    var fill  = document.getElementById('flowFill');
    if (!track || !fill) return;

    var steps   = Array.prototype.slice.call(track.querySelectorAll('.flowmap-step'));
    if (!steps.length) return;
    var lineEl  = track.querySelector('.flowmap-line');
    var markers = steps.map(function (s) { return s.querySelector('.flowmap-marker'); });
    var last    = steps.length - 1;

    var centers = [], firstC = 0, curIdx = 0;

    /* Misura il centro Y di ogni marker rispetto al track: la linea
       e il riempimento si ancorano ai marker, non a percentuali. */
    function measure() {
        var tr = track.getBoundingClientRect();
        centers = markers.map(function (m) {
            var r = m.getBoundingClientRect();
            return (r.top - tr.top) + r.height / 2;
        });
        firstC = centers[0];
        if (lineEl) {
            lineEl.style.top = firstC + 'px';
            lineEl.style.bottom = 'auto';
            lineEl.style.height = (centers[last] - firstC) + 'px';
        }
        fill.style.top = firstC + 'px';
    }
    function applyFill(i) {
        fill.style.height = Math.max(0, centers[i] - firstC) + 'px';
    }

    if (reduced) {
        measure();
        steps.forEach(function (s) { s.classList.add('is-on'); });
        applyFill(last);
        return;
    }

    var timer = null, i = 0;

    function light(idx) {
        curIdx = idx;
        steps.forEach(function (s, k) { s.classList.toggle('is-on', k <= idx); });
        applyFill(idx);
    }

    function tick() {
        light(i);
        if (i >= last) {
            timer = setTimeout(reset, 1700);
        } else {
            i++;
            timer = setTimeout(tick, 900);
        }
    }

    function reset() {
        i = 0;
        steps.forEach(function (s) { s.classList.remove('is-on'); });
        /* azzera senza transizione per evitare il "ritorno" della linea */
        var t = fill.style.transition;
        fill.style.transition = 'none';
        fill.style.height = '0px';
        void fill.offsetHeight;
        fill.style.transition = t;
        timer = setTimeout(tick, 450);
    }

    /* Il widget è above-the-fold: avvia dopo il caricamento dei font
       (come la timeline della home), senza dipendere da IntersectionObserver. */
    function start() {
        requestAnimationFrame(function () {
            measure();
            timer = setTimeout(tick, 400);
        });
    }
    if (document.fonts && document.fonts.ready) {
        document.fonts.ready.then(start);
    } else {
        start();
    }

    var rt;
    window.addEventListener('resize', function () {
        clearTimeout(rt);
        rt = setTimeout(function () { measure(); applyFill(curIdx); }, 150);
    });
})();

/* FAQ accordion e riordino campo "Cosa fai principalmente" del form CTA:
   spostati in product-2026.js perché generici a qualunque pagina prodotto,
   non specifici di Cleve. */
